import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Bookings from './pages/bookings';
import ContentManagement from './pages/contentManagement';
import Login from './pages/login';
import NavigationManagement from './pages/NavigationManagement';
import ExhibitorsManagement from './pages/ExhibitorsManagement';
import AccessDenied from './pages/accessDenied';
import NotFound from './pages/NotFound.jsx';
import SchedulingManagement from './pages/schedulingManagement.jsx';

const Path = () => {
    return ( <>
    <BrowserRouter>
        <Routes>
            <Route path='/' element={<Login />} />
            <Route path='/Home' element={<Home />} />
            <Route path='/Bookings' element={<Bookings />} />
            <Route path='/Exhibitors' element={<ExhibitorsManagement />} />
            <Route path='/Navigation' element={<NavigationManagement />} />
            <Route path='/ContentManagement' element={<ContentManagement />} />
            <Route path='/Scheduling' element={<SchedulingManagement />} />
            <Route path='/AccessDenied' element={<AccessDenied />} />
            <Route path='*' element={<NotFound />} />
        </Routes>
    </BrowserRouter>
    </> );
}
 
export default Path;